export const formatter = new Intl.NumberFormat('ru-Ru', {
    style: 'currency',
    currency: 'RUB',
});